import MyProfile from 'components/settings/myProfile';

export default function Profile() {
    return (
      <div>
        <MyProfile />
      </div>
    );
}
